import { useEffect, useState } from "react";
import { useLocation } from "react-router";

const ScrollTopBtn = () => {
  const location = useLocation();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const toggleVisibility = () => {
      if (window.pageYOffset > 300) {
        setVisible(true);
      } else {
        setVisible(false);
      }
    };
    window.addEventListener("scroll", toggleVisibility);
    return () => window.removeEventListener("scroll", toggleVisibility);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
    });
  };

  return (
    <>
      {visible && (
        <button
          onClick={scrollToTop}
          className={`scroll-to-top-btn ${
            location.pathname === "/"
              ? "background-green"
              : location.pathname === "/about"
              ? "background-green"
              : location.pathname === "/articles"
              ? "background-orange"
              : location.pathname === "/classes"
              ? "background-pink"
              : location.pathname === "/shop"
              ? "background-blue"
              : location.pathname === "/videos"
              ? "background-purple"
              : location.pathname === "/register"
              ? "background-red"
              : location.pathname === "/contact"
              ? "background-lightgreen"
              : location.pathname === "/question"
              ? "background-black"
              : "background-green"
          }`}
          aria-label="Scroll to top"
        >
          ↑
        </button>
      )}
    </>
  );
};

export default ScrollTopBtn;
